// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UAX33","textContainer":"styles_textContainer__jnXdp","text":"styles_text__iQbvy","description":"styles_description__Kz1KE"};